import * as Turbo from '@hotwired/turbo';

Turbo.session.drive = false;

// Turbo has no built-in stream action to navigate; this lets a turbo-stream
// response trigger a full-page redirect (e.g. once a CSV import succeeds).
Turbo.StreamActions.redirect = function () {
  window.location.assign(this.getAttribute('url'));
};

export default Turbo;
